import styled from "styled-components";

export const Root = styled.div`
  display: none;

  ${props => props.theme.breakpointsV2.smallTablet} {
    display: block;
  }
`;
